
import AppLayout from '../../components/feature/AppLayout';
import KanbanSection from '../home/components/KanbanSection';

export default function AcompanhamentoPage() {
  return (
    <AppLayout>
      <KanbanSection />
    </AppLayout>
  );
}

